import { useNavigate } from 'react-router'

import { useCan } from '@/auth'
import { Button, Dialog } from '@/design'
import { useUpgradePromptStore } from './upgrade-prompt-store'

/** Mounted once in the app shell; opens whenever a mutation answers `PLAN_LIMIT_REACHED`. */
export function UpgradePromptDialog() {
  const details = useUpgradePromptStore((state) => state.details)
  const dismiss = useUpgradePromptStore((state) => state.dismiss)
  const canBilling = useCan('billing:read')
  const navigate = useNavigate()
  const open = details !== null
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) dismiss()
      }}
      title="Plan limit reached"
      description={details?.message}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={dismiss}>
            Not now
          </Button>
          {canBilling && (
            <Button
              variant="primary"
              onClick={() => {
                dismiss()
                void navigate('/settings/billing')
              }}
            >
              See plans
            </Button>
          )}
        </>
      }
    >
      {details !== null && (
        <p className="text-[13px] text-muted">
          Your <span className="font-semibold text-ink">{details.plan}</span> plan allows{' '}
          {details.limit === null ? 'no more' : details.limit.toLocaleString('en-US')}{' '}
          {details.resource}.{' '}
          {canBilling
            ? 'Upgrading takes effect immediately; nothing is deleted.'
            : 'Ask an owner to upgrade the plan; nothing is deleted.'}
        </p>
      )}
    </Dialog>
  )
}
